<template>
  <Head>
    <template v-for="link in validHrefLangs" :key="link.hid">
      <Link
        :id="link.hid"
        :rel="link.rel"
        :href="baseUrl + link.href"
        :hreflang="link.hreflang"
      />
    </template>
  </Head>
  <div class="layout-default">
    <Navbar />
    <div class="page">
      <slot />
    </div>
    <SEOItem />
    <Footer class="footer" />
  </div>
</template>
<script setup lang="ts">
const head = useLocaleHead();

const url = useRequestURL();
const baseUrl = url.protocol + "//" + url.host;

/** Since AlleFolders doesn't use any other locale besides Dutch, we add do some filtering to grab the correct `hreflang`s from the `useLocaleHead`. */
const validHrefLangs = computed(() => {
  const promopromoLangs = ["x-default", "nl-BE", "fr"];
  const alleFoldersLangs = ["x-default", "nl-NL"];
  if (useCurrentHost().value === "promopromo") {
    return head.value.link.filter((l) => promopromoLangs.includes(l.hreflang));
  } else
    return head.value.link.filter((l) => alleFoldersLangs.includes(l.hreflang));
});
</script>
<style lang="scss" scoped>
.layout-default {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
  position: relative;
  touch-action: pan-y;

  .page {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .footer {
    margin-top: auto;
  }
}
</style>
